const inContnetFullWidth = () => {
  // on resize
  window.addEventListener('resize', () => {
    setContentFullWidth();
  });

  // on load
  setContentFullWidth();
}

function setContentFullWidth() {
  document.querySelectorAll(`.newspost .full, .eventpost .full, .contentpage .full`).forEach(item => {
    if (isLgSize()) {
      const list = document.querySelector(`.side-nav`).parentElement;
      if (list) {
        const rect = list.getBoundingClientRect(),
          width = rect.width;
        item.style.marginLeft = `-${width}px`;
        item.style.maxWidth = `calc( 100% + ${width}px - 1rem)`;
      }
    } else {
      item.style.marginLeft = '';
      item.style.maxWidth = '';
    }
  });
}

function isLgSize() {
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  if (width > 1023) {
    return true;
  }

  return false;
}

export default inContnetFullWidth;
